<template>
  <!-- loader-pinwheel     -->
  <IconLucideLoaderPinwheel />
</template>
